import { IntegrationResponse, IntegrationType } from '@kcftech/prometheus-client';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient, resultsOf } from 'utils/query';
import { Filter } from 'utils/query_v3';

const queryKey = 'active-integration';

export function useActiveIntegration(
    locationId: string,
    integrationType: IntegrationType,
    options?: Partial<UseQueryOptions<IntegrationResponse | undefined, Partial<Error>>>,
) {
    const filter = Filter.and(
        Filter.eq('Active', true),
        Filter.eq('IntegrationType', integrationType),
        Filter.eq('IsDeleted', false),
    );
    return useQuery<IntegrationResponse | undefined, Partial<Error>>({
        ...options,
        queryKey: [queryKey, locationId, integrationType],
        queryFn: () =>
            sdClient
                .getIntegrationsForLocation({ id: locationId, filter })
                .then((r) => r.Result[0] ?? null),
    });
}

export function useActiveIntegrations(locationId: string) {
    const filter = Filter.and(Filter.eq('Active', true), Filter.eq('IsDeleted', false));
    return useQuery<IntegrationResponse[] | undefined, Partial<Error>>({
        queryKey: [queryKey, locationId, 'all'],
        queryFn: () =>
            resultsOf(sdClient.getIntegrationsForLocation({ id: locationId, filter })),
    });
}

export function invalidateActiveIntegrations(
    locationId: string,
    integrationType?: IntegrationType | 'all',
) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, locationId, integrationType],
    });
}
